import api from './api';
import { UsageStats } from '../types/usage.types';

class UsageService {
  /**
   * Get current usage statistics for the authenticated user
   */
  async getUsageStatus(): Promise<UsageStats> {
    return await api.get<UsageStats>('/api/usage');
  }

  /**
   * Track a Figma export
   */
  async trackFigmaExport(artifactId?: string, projectId?: string): Promise<{
    success: boolean;
    usage: {
      figmaExportCount: number;
      lifetimeFigmaExportCount: number;
    };
  }> {
    return await api.post('/api/exports/figma', { artifactId, projectId });
  }

  /**
   * Track a download/export by format for admin analytics. Fire-and-forget:
   * failures are swallowed so a network error never breaks a successful download.
   */
  async trackDownload(format: 'png' | 'jpeg' | 'svg' | 'figma'): Promise<void> {
    try {
      await api.post('/api/exports/track', { format });
    } catch (err) {
      console.warn('Failed to track download:', err);
    }
  }
}

const usageService = new UsageService();
export default usageService;
